import { Button, Drawer, Stack, TextField } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { queryClient } from '../../../../App'
import { markOrderAsDuplicateAdministration } from '../../../../services/ApiService'
import DrawerHeader from '../../../Service/components/NewDrawers/components/DrawerHeader'
import TypedAccordion from '../../../SingleRequestPage/components/SingleRequestDrawer/elements/TypedAccordion'
import { REQUEST_CLARIFICATION_KEYS } from '../../RequestsSecondOperator/Table/hooks/useRequestsData'
import { changeOperatorStatusStore } from './ChangeOperatorStatusStore'

export const MARK_AS_DUPLICATE_ADMINISTRATION =
  'mark-as-duplicate-administration'

const ChangeOperatorStatusDrawer = () => {
  const [comment, setComment] = useState('')
  const { isOpen, setIsOpen, requestId, setRequestId, updateOrderCallback } =
    changeOperatorStatusStore

  const { mutateAsync } = useMutation({
    mutationKey: [MARK_AS_DUPLICATE_ADMINISTRATION],
    mutationFn: (params: { orderId: number; comment: string }) =>
      markOrderAsDuplicateAdministration(params),
  })
  const onClose = () => {
    setRequestId(null)
    setIsOpen(false)
    setComment('')
  }

  const onSubmit = async () => {
    const res = await mutateAsync({ orderId: requestId ?? 0, comment })
    if (res?.id) {
      updateOrderCallback && updateOrderCallback(res)
      queryClient.invalidateQueries({
        queryKey: [REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE],
      })
      setIsOpen(false)
      setComment('')
    }
  }

  return (
    <Drawer
      anchor={'right'}
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 380,
        },
      }}
    >
      <DrawerHeader
        title={`Заявка №${String(requestId ?? 0).padStart(6, '0')}`}
        onBack={onClose}
        onClose={onClose}
      />
      <Stack sx={{ padding: '68px 0 40px 0' }} spacing={'16px'}>
        <TypedAccordion
          summary={'Причина перевода заявки в статус дубликат'}
          customOpen
        >
          <TextField
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            multiline
            rows={4}
            placeholder='Введите комментарий'
            fullWidth
          />
        </TypedAccordion>
        <Button
          variant='contained'
          disabled={!comment.length}
          sx={{ marginX: '16px!important' }}
          onClick={onSubmit}
        >
          Перевести в дубликат
        </Button>
      </Stack>
    </Drawer>
  )
}

export default observer(ChangeOperatorStatusDrawer)
